import { render, staticRenderFns } from "./displayCurrencyQuotes.vue?vue&type=template&id=2e0f113f&scoped=true&"
import script from "./displayCurrencyQuotes.vue?vue&type=script&lang=js&"
export * from "./displayCurrencyQuotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0f113f",
  null
  
)

export default component.exports